import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { apiCall, removeParam } from '../../utils';


const IntegrationContaAzul = () => {
  const [isCompany, setIsCompany] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branches, setBusinessBranches] = useState([]);
  const [hasAuthCode, setAuthCode] = useState(false);
  const [hasAuthState, setAuthState] = useState(false);
  const interval = useRef(null);

  const initData = () => {
    let userProfileResponse = { ...window._sessionData };
    if (!Array.isArray(userProfileResponse.businessBranches)) {
      userProfileResponse.businessBranches = Object.keys(userProfileResponse.businessBranches).map((key) => {
        return userProfileResponse.businessBranches[key];
      });
    }
    setBusinessBranches(userProfileResponse.businessBranches);

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const code = params.get('code');
    const state = params.get('state');
    setAuthCode(code);
    setAuthState(state);
    clearInterval(interval.current);
  }

  React.useEffect(() => {
    interval.current = setInterval(() => {
      if (window._sessionData.businessBranches && branches.length === 0) {
        initData();
      }
    }, 1000);
  
  }, []);

  const handleContaAzulFinalIntegration = (customBranchId = null) => {
    if (isLoading) return;
    setIsLoading(true);
    apiCall({
      method: 'POST',
      endpoint: 'api/v1/integrations/conta-azul/start-integration',
      data: {
        branchId: `${customBranchId ? customBranchId : selectedBranch}`,
        code: hasAuthCode
      },
      successCallback: function(res) {
        setIsLoading(false);
        window.toast({
          error: res.error,
          text: res.message
        })
        if (res.error) {

        } else {
          removeParam('code')
          removeParam('state')
          setAuthCode(false);
          setAuthState(false);
          if (!Array.isArray(res.branches)) {
            res.branches = Object.keys(res.branches).map((key) => {
              return res.branches[key];
            });
          }
          setBusinessBranches(res.branches);
        }
      },
      errorCallback: function(res) {
        setIsLoading(false);
      }
    })
  }

  const handleRemoveAuthCode = () => {
    setAuthCode(false);
    removeParam('code')
    setAuthState(false);
    removeParam('state')
  }

  const handleContaAzulDisconnect = () => {
    if (isLoading) return;
    setIsLoading(true);
    apiCall({
      method: 'POST',
      endpoint: 'api/v1/integrations/conta-azul/remove-integration',
      data: {
        branchId: `${selectedBranch}`
      },
      successCallback: function(res) {
        setIsLoading(false);
        window.toast({
          error: res.error,
          text: res.message
        })
        if (res.error) {

        } else {
          removeParam('code')
          setAuthCode(false);
          removeParam('state')
          setAuthState(false);
          if (!Array.isArray(res.branches)) {
            res.branches = Object.keys(res.branches).map((key) => {
              return res.branches[key];
            });
          }
          setBusinessBranches(res.branches);
        }
      },
      errorCallback: function(res) {
        setIsLoading(false);
      }
    })
  }

  React.useEffect(() => {
    if (branches.length > 0) {
      if (hasAuthCode && hasAuthState) {
        setSelectedBranch(hasAuthState);
        handleContaAzulFinalIntegration(hasAuthState);
      }
    }
  }, [branches, hasAuthState]);

  return (
    <div className="js-conta-azul-integration-container p-1">
      <p className="lead m-0">Integração com Conta Azul</p>
      <p>Você deseja conectar o Conta Azul por filial?</p>

      {hasAuthCode && (
        <div class="alert alert-info" role="alert">
          Quase lá! Agora selecione uma filial &raquo; e clique em <b>Finalizar Conexão</b>.
          <br />
          P.S: Caso ocorra algum erro ao clicar em "Finalizar Conexão", clique em "Cancelar Conexão" e tente novamente.
        </div>
      )}

      <div className="mt-3">
        <label className="form-label">Selecione uma filial</label>
        <select className="form-select" onChange={(e) => {
          setSelectedBranch(e.target.value);
        }}>
          <option value="">-- Selecione uma opção --</option>
          {branches && (branches?.map((branch) => (
            <option value={branch.ID} selected={selectedBranch == branch.ID ? true : false}>{branch.FILIAL}</option>
          )))}
        </select>

        <div className="mt-3">
          {selectedBranch && !hasAuthCode && (!branches.filter(v => v.ID == selectedBranch)?.[0].METADATA?.integrations?.conta_azul) && (
            <div className="mt-3">
              <a href={`https://api.contaazul.com/auth/authorize?client_id=3OWrpeVaySuaoVWwWcbeN3DwHPu9SJRl&redirect_uri=https%3A%2F%2Fmarketing.clinicasajustar.com.br%2Fintegracoes%2Fresposta%3Ftipo%3Dcontaazul%26callback_uri%3Dintegracoes%252Fconta-azul%26cadastro%3Dfilial%26filial%3D${selectedBranch}&scope=sales&state=${selectedBranch}`} className="btn btn-primary">Conectar Conta Azul</a>
            </div>
          )}

          {hasAuthCode && selectedBranch && (
            (
            <div className="mt-3">
              <a href="javascript:void(0);" className="btn btn-primary" onClick={handleContaAzulFinalIntegration} disabled={isLoading}>Finalizar conexão</a>
              &nbsp;
              <a href="javascript:void(0);" className="btn btn-danger" onClick={handleRemoveAuthCode} disabled={isLoading}>Cancelar</a>
            </div>
            )
          )}

          {(hasAuthCode || !hasAuthCode) && branches.filter(v => v.ID == selectedBranch)?.[0] && (branches.filter(v => v.ID == selectedBranch)?.[0].METADATA?.integrations?.conta_azul?.expires_in && (
            <div className="mt-3">
              <a href="javascript:void(0);" className="btn btn-danger" onClick={handleContaAzulDisconnect} disabled={isLoading}>Desconectar Conta Azul</a>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
};

try {
  if (document.getElementById('js-conta-azul-integration-container')) {
    const container = document.getElementById('js-conta-azul-integration-container');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<IntegrationContaAzul />);
  }
} catch(err) {
  console.error('Error rendering IntegrationContaAzulPage: ', err);
}